export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref7560.22ab66e5.jpg";